const UpdateCascadePlanHierarchyApi = async (planId, hierarchyOrder) => {
  try {
    const token = 'Bearer ' + localStorage.getItem('authToken');
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/${planId}/hierarchy-order`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({ hierarchyOrder }),
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating cascade plan hierarchy:', error);
    return { success: false, error: error.message };
  }
};

export default UpdateCascadePlanHierarchyApi;